import { render, staticRenderFns } from "./ContractLogsList.vue?vue&type=template&id=4a796e12&scoped=true&"
import script from "./ContractLogsList.vue?vue&type=script&lang=js&"
export * from "./ContractLogsList.vue?vue&type=script&lang=js&"
import style0 from "./ContractLogsList.vue?vue&type=style&index=0&id=4a796e12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a796e12",
  null
  
)

export default component.exports